/**
 * The server refuses a guest's meeting-token join with "This meeting is currently unavailable."
 * when the host company is suspended or deleted (SC-409). That can happen after the join page
 * loaded, so `guestJoinFailureReason` (utils/guestFarewellUrl.ts) maps it to the "ended" farewell,
 * which offers no retry. The wording is neutral on purpose: a guest is not told why. Other
 * refusals, such as the server's retry text for a transient company read failure, must not match.
 */
export function isGuestMeetingUnavailableError(error: unknown): boolean {
  return typeof error === 'string' && error.includes('currently unavailable')
}
